exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-spinner[data-v-375a9b9e]{text-align:center;border-radius:4px;padding:30px 50px}.movements-map[data-v-375a9b9e]{margin:-24px;height:300px}.movements-info[data-v-375a9b9e]{margin-top:48px}.ant-steps-dot.ant-steps-small .ant-steps-item-content[data-v-375a9b9e],[data-v-375a9b9e] .ant-steps-dot .ant-steps-item-content{width:inherit}", ""]);

// exports
